/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".jumbotron[_ngcontent-%COMP%]{padding:30px;border-radius:10px;box-shadow:0 5px 3px #cccc}.navbar-nav[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{border-bottom:3px solid orange}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
